<template>
  <div class="file-pdf">
    <iframe
      v-if="canPreview"
      :src="file.file_64"
      class="pdf-frame"
    />
    <v-btn
      v-else
      color="primary"
      @click="downloadFile"
    >
      Download {{ file.name }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "FilePdf",
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  computed: {
    canPreview() {
      return this.file.file_64?.startsWith("data:application/pdf");
    }
  },
  methods: {
    downloadFile() {
      const link = document.createElement("a");
      link.href = this.file.file_64;
      link.download = this.file.name || "download.pdf";
      link.click();
    }
  }
};
</script>

<style scoped>
.pdf-frame {
  width: 100%;
  height: 70vh;
  border: none;
  border-radius: 8px;
}
</style>